import React from 'react';
import { Routes } from './modules/router/components/routes';
import { Providers } from './providers';
export const App = () => {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}